import { EventHandler, WithDelegateTarget } from "../../utils/event-handler";
import { EVENT_CHANGE } from "../../utils/events";

export class ProjectListForm {
    #SELECTOR_FORM = '.project-list';
    #SELECTOR_FORM_WRAPPER = `${this.#SELECTOR_FORM}-form`;
    #SELECTOR_ACTIVE_FILTERS_WRAPPER = `${this.#SELECTOR_FORM}-active-filters`;

    #CLASS_NAME_SELECT_ACTIVE = 'active';

    #wrapper: HTMLElement;
    #activeFilters: HTMLElement;

    constructor() {
        this.#initElements();
        this.#initEvents();
    }

    #initElements(): void {
        this.#wrapper = document.querySelector(this.#SELECTOR_FORM_WRAPPER);
        this.#activeFilters = document.querySelector(this.#SELECTOR_ACTIVE_FILTERS_WRAPPER);

        Array.from(document.querySelectorAll(`${this.#SELECTOR_FORM_WRAPPER} select:valid`)).forEach((select: HTMLSelectElement) => {
            this.#selectChanged(select);
        });

        if ((<HTMLInputElement>this.#wrapper.querySelector('[name="q"]'))?.value) {
            window.scrollBy({
                top: this.#wrapper.getBoundingClientRect().top,
                behavior: "smooth",
            });
        }
    }

    #initEvents(): void {
        EventHandler.on(document, EVENT_CHANGE, `${this.#SELECTOR_FORM_WRAPPER} select`, (event: WithDelegateTarget<Event>) => {
            this.#selectChanged(<HTMLSelectElement>event.delegateTarget);
        });
    }

    #selectChanged(select: HTMLSelectElement): void {
        this.#toggleLabelActiveState(select.labels[0], select.validity.valid);

        this.#updateSelectedLabel(select.labels[0], select);
    }

    #toggleLabelActiveState(label: HTMLLabelElement, toggle: boolean): void {
        if (toggle) {
            label.classList.add(this.#CLASS_NAME_SELECT_ACTIVE);
        } else {
            label.classList.remove(this.#CLASS_NAME_SELECT_ACTIVE);
        }
    }

    #updateSelectedLabel(label: HTMLLabelElement, select: HTMLSelectElement): void {
        label.querySelector('span').innerText = select.selectedOptions[0].label;
    }

}
